import {
  ThematicPackageBudgetTierId,
  ThematicPackageBudgetTierIds,
  ThematicPackageBudgetTierResponse,
} from '@features/campaigns/shared/types/campaignSubmit.ts';

const KNOWN_TIER_IDS: ThematicPackageBudgetTierId[] = Object.values(ThematicPackageBudgetTierIds);

// Shared so the tier cards and the custom-budget floor agree on which tiers exist.
export function isKnownBudgetTier({ id }: ThematicPackageBudgetTierResponse): boolean {
  return KNOWN_TIER_IDS.includes(id);
}
